import React from 'react';

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    UnorderedListOutlined,
    PlusSquareOutlined,
    TableOutlined,
    ShareAltOutlined,
    CarOutlined,
    UserOutlined,
    DeleteOutlined,
    HeartOutlined,
    CloudSyncOutlined
} from '@ant-design/icons';

// icons
const icons = {
    UnorderedListOutlined,
    PlusSquareOutlined,
    TableOutlined,
    ShareAltOutlined,
    CarOutlined,
    UserOutlined,
    DeleteOutlined,
    HeartOutlined,
    CloudSyncOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const superAdmin = {
    id: 'super_admin',
    title: <FormattedMessage id="superAdmin" />,
    type: 'group',
    children: [
        {
            id: 'healthDashboard',
            title: <FormattedMessage id="healthDashboard" />,
            type: 'item',
            url: '/health-dashboard',
            icon: icons.HeartOutlined
        },
        {
            id: 'organizations',
            title: <FormattedMessage id="organizations" />,
            type: 'item',
            url: '/orgs',
            icon: icons.UnorderedListOutlined
        },
        {
            id: 'createOrg',
            title: <FormattedMessage id="createOrg" />,
            type: 'item',
            url: '/create-org',
            icon: icons.PlusSquareOutlined
        },
        {
            id: 'reports',
            title: <FormattedMessage id="reports" />,
            type: 'item',
            url: '/reports',
            icon: icons.TableOutlined
        },
        {
            id: 'sharingAgreements',
            title: <FormattedMessage id="sharingAgreements" />,
            type: 'item',
            url: '/sharing-agreements',
            icon: icons.ShareAltOutlined
        },
        {
            id: 'lprInspection',
            title: <FormattedMessage id="lprInspection" />,
            type: 'item',
            url: '/lpr-inspection',
            icon: icons.CarOutlined
        },
        {
            id: 'virtualGuards',
            title: <FormattedMessage id="virtualGuard" />,
            type: 'item',
            url: '/virtual-guards',
            icon: icons.UserOutlined
        },
        {
            id: 'accountDeletion',
            title: <FormattedMessage id="accountDeletion" />,
            type: 'item',
            url: '/account-deletion',
            icon: icons.DeleteOutlined
        },
        {
            id: 'appVersions',
            title: <FormattedMessage id="appVersions" />,
            type: 'item',
            url: '/app-versions',
            icon: icons.CloudSyncOutlined
        }
    ]
};

export default superAdmin;
